import React, { Component, PropTypes } from 'react';
import { Modal } from 'react-bootstrap';
import { connectReduxForm } from 'redux-form';
import { validateChangeEmail } from 'utils/validateNormalize';
import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './spinnerButton.scss';
import './changeEmailModal.scss';

@connectReduxForm({
  form: 'changeEmail',
  fields: ['email', 'password', 'alert'],
  validate: validateChangeEmail
})
export default class ChangeEmailModal extends Component {

  static propTypes = {
    showModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  handleSubmit (evt) {
    const {
      fields: {
        alert
      },
      handleSubmit
    } = this.props;
    alert.submitError = false;
    handleSubmit(evt);
  }

  render () {
    const {
      showModal,
      closeModal,
      fields: {
        alert,
        email,
        password},
      submitting
    } = this.props;

    return (
      <Modal show={showModal} onHide={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Change Email</Modal.Title>
        </Modal.Header>
        <form onSubmit={::this.handleSubmit}>
          <Modal.Body className="col-sm-8 col-md-12">
            { alert.error &&
              <div className="form-group">
                <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}>
                </div>
              </div>
            }

              <div className="col-sm-12 col-md-12">

                <div className="row">
                  <div className={'form-group ' +
                                  (email.error && email.touched && 'has-error')}>
                    <label htmlFor="txtEmail"
                           className="newEmailLabel col-sm-3 control-label">
                      New Email
                    </label>
                    <div className="col-sm-9 newEmailInputDiv">
                      <input id="txtEmail"
                             type="email"
                             className="form-control"
                             placeholder="jane@example.com"
                             spellCheck="false"
                             {...email} />
                      {email.error && email.touched &&
                       <div className="text-danger" dangerouslySetInnerHTML={{__html: email.error}}></div>
                      }
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className={'form-group ' +
                                  (password.error && password.touched ? 'has-error' : '')}>
                    <label htmlFor="txtPassword"
                           className="passwordLabel col-sm-3 control-label">
                      Password
                    </label>
                    <div className="col-sm-9 passwordInputDiv">
                      <input id="txtPass"
                             type="password"
                             className="form-control"
                             placeholder="thoo!mu3Da"
                             {...password} />
                      {password.error && password.touched &&
                        <div className="text-danger" dangerouslySetInnerHTML={{__html: password.error}}></div>
                      }
                    </div>
                  </div>
                </div>

              </div>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit"
                    className={'btn btn-primary spinnerButton ' +
                               (submitting ? 'disabled' : '')}>
              <div className="buttonContent">
                <div className="buttonText">
                  {submitting ?
                    'Submitting' :
                    'Submit'
                  }
                </div>
                {submitting &&
                <div className="spinnerWrapper">
                  <Spinner />
                </div>
                }
              </div>
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/changeEmailModal.jsx